import { render, staticRenderFns } from "./DesktopLayout.vue?vue&type=template&id=262dbf84&scoped=true&"
import script from "./DesktopLayout.vue?vue&type=script&lang=js&"
export * from "./DesktopLayout.vue?vue&type=script&lang=js&"
import style0 from "./DesktopLayout.vue?vue&type=style&index=0&id=262dbf84&lang=scss&scoped=true&"
import style1 from "./DesktopLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262dbf84",
  null
  
)

export default component.exports